export enum TelephonyCallStateEnum {
  None,
  Ringing,
  Answered,
  Ended,
  OnHold,
}
